import * as yup from 'yup';

export const EnterpriseUpgradeModalSchema = yup.object().shape({
    FirstName: yup.string().required(),
    LastName: yup.string().required(),
    CompanyName: yup.string().required(),
    PhoneNumber: yup.string().required(),
    EmailAddress: yup.string().email().required(),
    Website: yup.string(),
    Industry: yup.string().required(),
    Country: yup.string().required(),
    Description: yup.string().required(),
})